const n = {
  name: "ChevronUp",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18.9998 16.4141L11.9998 9.41406L4.99985 16.4141L3.58563 14.9998L11.9998 6.58564L20.4141 14.9998L18.9998 16.4141Z" fill="currentColor"/>
</svg>
  `
};
export {
  n as ChevronUp
};
